import { Product } from '../types';

interface ProductCardProps {
  product: Product;
}

export const ProductCard = ({ product }: ProductCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      {product.image && (
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-48 object-cover"
        />
      )}
      <div className="p-4">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          {product.name}
        </h3>
        <p className="text-gray-600 mb-2">{product.description}</p>
        <div className="flex items-center justify-between">
          <span className="text-lg font-bold text-primary-600">
            ${product.price}
          </span>
          <button
            className="bg-primary-600 text-white px-4 py-2 rounded hover:bg-primary-700 transition-colors"
            onClick={() => {/* TODO: Add to cart functionality */}}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}; 